module.exports = __webpack_public_path__ + "static/media/photo41.7e5318f5.jpg";